var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c(
        "el-form",
        {
          staticStyle: { display: "flex" },
          attrs: {
            disabled: _vm.disabled,
            "label-position": "right",
            "label-width": "100px"
          }
        },
        _vm._l(_vm.upElementBlocks, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "section form-column",
              style: { width: item.width + "px" }
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(item.title))
              ]),
              item.name === "consigneeShipperNotifyInfo"
                ? _vm._t("detailFormat")
                : _vm._e(),
              _vm._l(item.elementNames, function(elementName) {
                return _vm._t(elementName)
              })
            ],
            2
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }